module.exports = __webpack_public_path__ + "38775648154e78f980ac11109e174deb.pdf";